const once = window.once;

/**
 * @file hero.js
 *
 * Drupal behavior for the Hero component.
 * Handles:
 *  - Background video playback toggle
 *  - Video mute / unmute toggle
 *  - Reduced motion support
 */

(function (Drupal, once) {
  'use strict';

  if (!Drupal || !once) {
    console.warn('Drupal or once not available');
    return;
  }

  function parseDurationSeconds(value) {
    if (value === null || value === undefined || value === '') {
      return 0;
    }

    if (typeof value === 'number') {
      return value;
    }

    var trimmed = String(value).trim();
    if (!trimmed) {
      return 0;
    }

    if (/^\d+(\.\d+)?$/.test(trimmed)) {
      return parseFloat(trimmed);
    }

    var timeParts = trimmed.split(':').map(function (part) {
      return Number(part);
    });

    if (timeParts.length === 3) {
      return (timeParts[0] * 3600) + (timeParts[1] * 60) + timeParts[2];
    }

    if (timeParts.length === 2) {
      return (timeParts[0] * 60) + timeParts[1];
    }

    return parseFloat(trimmed) || 0;
  }

  Drupal.behaviors.hero = {
    attach: function (context) {

      once('hero', '.hero', context).forEach(function (hero) {

        var video = hero.querySelector('.hero__video');
        var playbackBtn = hero.querySelector('.hero__btn--playback');
        var volumeBtn = hero.querySelector('.hero__btn--volume');

        if (!video) {
          return;
        }

        /**
         * Update Play/Pause UI
         */
        function updatePlaybackUI() {

          if (!playbackBtn) {
            return;
          }

          var playIcon = playbackBtn.querySelector('.hero__icon--play');
          var pauseIcon = playbackBtn.querySelector('.hero__icon--pause');

          if (video.paused) {

            playbackBtn.classList.add('is-paused');
            playbackBtn.setAttribute('aria-label', 'Play video');
            playbackBtn.setAttribute('aria-pressed', 'false');

            if (playIcon) {
              playIcon.style.opacity = '1';
              playIcon.style.pointerEvents = 'auto';
              playIcon.style.cursor = 'pointer';
            }

            if (pauseIcon) {
              pauseIcon.style.opacity = '0.5';
              pauseIcon.style.pointerEvents = 'none';
              pauseIcon.style.cursor = 'default';
            }

          } else {

            playbackBtn.classList.remove('is-paused');
            playbackBtn.setAttribute('aria-label', 'Pause video');
            playbackBtn.setAttribute('aria-pressed', 'true');

            if (playIcon) {
              playIcon.style.opacity = '0.5';
              playIcon.style.pointerEvents = 'none';
              playIcon.style.cursor = 'default';
            }

            if (pauseIcon) {
              pauseIcon.style.opacity = '1';
              pauseIcon.style.pointerEvents = 'auto';
              pauseIcon.style.cursor = 'pointer';
            }
          }
        }

        // --------------------------------------------------
        // Reduced Motion
        // --------------------------------------------------
        var prefersReducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        if (prefersReducedMotion) {
          video.pause();
        }

        function configureVideoLoop() {
          if (!video.hasAttribute('data-loop') || !isFinite(video.duration)) {
            return;
          }

          if (video.duration >= 5) {
            video.loop = true;
            return;
          }

          video.loop = false;
          var playCount = 0;

          video.addEventListener('ended', function () {
            playCount += 1;

            if (playCount < 8) {
              video.currentTime = 0;
              video.play();
            }
          });
        }

        if (video.readyState >= 1) {
          configureVideoLoop();
        } else {
          video.addEventListener('loadedmetadata', configureVideoLoop, { once: true });
        }

        // --------------------------------------------------
        // Playback Controls
        // --------------------------------------------------
        if (playbackBtn) {

          var playIcon = playbackBtn.querySelector('.hero__icon--play');
          var pauseIcon = playbackBtn.querySelector('.hero__icon--pause');

          // Play only when play icon is clicked
          if (playIcon) {
            playIcon.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              if (video.paused) {
                video.play();
              }
            });
          }

          // Pause only when pause icon is clicked
          if (pauseIcon) {
            pauseIcon.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              if (!video.paused) {
                video.pause();
              }
            });
          }

          video.addEventListener('play', updatePlaybackUI);
          video.addEventListener('pause', updatePlaybackUI);

          updatePlaybackUI();
        }

        // --------------------------------------------------
        // Volume Controls
        // --------------------------------------------------
        if (volumeBtn) {

          video.muted = true;

          volumeBtn.addEventListener('click', function () {

            if (video.muted) {
              video.muted = false;
              volumeBtn.classList.add('is-unmuted');
              volumeBtn.setAttribute('aria-label', 'Mute video');
              volumeBtn.setAttribute('aria-pressed', 'true');
            } else {
              video.muted = true;
              volumeBtn.classList.remove('is-unmuted');
              volumeBtn.setAttribute('aria-label', 'Unmute video');
              volumeBtn.setAttribute('aria-pressed', 'false');
            }
          });
        }
      });
    }
  };


  // --------------------------------------------------
  // Reveal Animation
  // --------------------------------------------------
  const elements = document.querySelectorAll('.hero__inner__content-wrapper--animated');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-animated');

        // Animation runs only once
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.3
  });

  elements.forEach(el => observer.observe(el));

})(Drupal, once);